import createSagaMiddleware from "redux-saga";
import { configureStore, compose, applyMiddleware, Tuple } from "@reduxjs/toolkit";
import rootSaga from "./sagas/rootSaga";
import reducers from "./reducers";
import { setUserAction } from "./reducers/userSlice";
import axios from "axios";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user'],
    blacklist: ['adminClients'],
  }

  const userPersistConfig = {
    key: 'user',
    storage,
    // blocklist: ['user']
    whitelist: ['user']
  }

  const persistedReducer = persistReducer(persistConfig, reducers)


const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => new Tuple(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production'
})

const userDetail: any = localStorage.getItem('user');
if(userDetail){
    // axios.defaults.headers.common["Authorization"] = "Bearer " + userDetail?.accessToken;
    // store.dispatch(setUserAction(JSON.parse(userDetail)))
}

sagaMiddleware.run(rootSaga);


export default store;
export const persistor = persistStore(store);
